module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_10-4ce5d46e959fcc8e180a7d5f3b2d5225.svg";